import { ComponentGroup } from '../types.js'

const icon = `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" style="enable-background:new 0 0 30 30;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:{{strokeColor}};}
    .st14{fill:none;stroke:{{strokeColor}};stroke-width:2.5;stroke-linecap:round;stroke-miterlimit:10;}
    .st15{fill:none;stroke:{{strokeColor}};stroke-linecap:round;stroke-miterlimit:10;}
  </style>
  <g>
    <polyline class="st14" points="1.5,11.2 15,5.2 28.5,11 	"/>
    <line class="st15" x1="3.2" y1="11.6" x2="3.2" y2="23.8"/>
    <line class="st15" x1="26.9" y1="11.6" x2="26.9" y2="23.8"/>
    <line class="st5" x1="1.7" y1="24.8" x2="28.3" y2="24.8"/>
    <rect x="21.1" y="18.3" class="st0" width="3.4" height="5.5"/>
    <path class="st0" d="M5.9,13.6v10.2h13.8V13.6H5.9z M18.7,17.3H6.8v-2.4h11.9V17.3z"/>
  </g>
</svg>
`

export const warehouse: ComponentGroup = {
  name: 'warehouse',
  description: 'a group of various components used in a warehouse depiction',
  icon,
  templates: []
}
